/**
 * Enum representing the rarity levels.
 * @enum {string}
 */
export enum Rarity {
  /**
   * Represents a very common rarity level.
   */
  VeryCommon = 'Very Common',

  /**
   * Represents a common rarity level.
   */
  Common = 'Common',

  /**
   * Represents a rare rarity level.
   */
  Rare = 'Rare',
}
